export default __webpack_public_path__ + "static/media/has_registered.ec32bd67.jpg";